// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo.svg";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.jpg";
// Tech stack images
import htmlImage from "./assets/techstack/html.png";
import cssImage from "./assets/techstack/css.png";
import sassImage from "./assets/techstack/sass.png";
import jsImage from "./assets/techstack/js.png";
import reactImage from "./assets/techstack/react.png";
import reduxImage from "./assets/techstack/redux.png";
import tailwindImage from "./assets/techstack/tailwind.png";
import githubImage from "./assets/techstack/github.png";
import gitImage from "./assets/techstack/git.png";
import npmImage from "./assets/techstack/npm.png";
import postmanImage from "./assets/techstack/postman.png";
import mongodbImage from "./assets/techstack/mongodb.png";
import expressImage from "./assets/techstack/express.png";
import mongooseImage from "./assets/techstack/mongoose.png";
import nextjsImage from "./assets/techstack/nextjs.png";
import nodeJsImage from "./assets/techstack/node-js.png";
import chakraUiImage from "./assets/techstack/chakra-ui.png";
import awsS3Image from "./assets/techstack/aws-s3.png";
import awsTextractImage from "./assets/techstack/aws-textract.png";
import gcpImage from "./assets/techstack/gcp.png";

// Porject Images
import projectImage1 from "./assets/projects/project1.png";
import projectImage3 from "./assets/projects/project3.png";
import projectImage5 from "./assets/projects/project5.png";

// Logos
export const logos = { logogradient, logo };

// Enter your Personal Details here
export const personalDetails = {
  name: "Ritik Singh",
  tagline: "I build innovative web",
  img: profile,
  about: [
    "Greetings! I'm Ritik, a passionate MERN developer dedicated to crafting websites that seamlessly blend frontend and backend technologies. With each project, I strive to expand my knowledge and embrace new skills. I'm eager to immerse myself in a dynamic work environment where I can contribute significantly to a company's growth trajectory.",
    "My aspiration is to thrive in a challenging setting as a specialized MERN stack developer, leveraging my expertise to tackle complex problems and drive innovative solutions. With a fervent commitment to excellence, I'm ready to embark on exciting projects that push the boundaries of what's possible in web development. Let's build something remarkable together!"
  ]
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/ritiksingh11661",
  github: "https://www.github.com/ritiksingh11661",
  instagram: "https://www.instagram.com/ritiksingh11661",
};

// Enter your Work Experience here
export const workDetails = [
  { Position: "Full Stack Developer", Company: "CodeApto India Pvt Ltd", Location: "Remote", Type: "Internship", Duration: "July 2023 - August 2023" },
  { Position: "Full Stack Developer", Company: "SEOHORIZON", Location: "Remote", Type: "Internship", Duration: "February 2024 - June 2024" },
  { Position: "Frontend Developer", Company: "AXTechnosoft", Location: "Noida, Uttar Pradesh", Type: "Internship", Duration: "September 1, 2024 - June 1, 2025" },
  { Position: "Frontend Developer", Company: "AXTechnosoft", Location: "Noida, Uttar Pradesh", Type: "Full-Time", Duration: "July 1, 2025 - March 1, 2026" }
];

// Calculate total work experience
export const calculateTotalExperience = () => {
  const monthDurations = [2, 5, 9, 8]; // July-Aug 2023, Feb-June 2024, Sept 2024-June 2025, July 2025-March 2026
  const totalMonths = monthDurations.reduce((a, b) => a + b, 0);
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;
  if (years === 0) return `${totalMonths}+ months`;
  return months === 0 ? `${years}+ years` : `${years}+ years ${months}+ months`;
};

// Enter your Education Details here
export const eduDetails = [
  { Position: "Full Stack Web Development", Company: "Masai", Location: "Online", Type: "Full Time", Duration: "April 2022 - May 2023" },
  // { Position: "Bachelor of Computer Applications", Company: "Indira Gandhi National Open University", Location: "Online", Type: "Part Time", Duration: "July 2023 - July 2026" },
];

// Tech Stack and Tools
export const techStackDetails = { html: [htmlImage, 'HTML'], css: [cssImage, 'CSS'], js: [jsImage, 'JavaScript'], react: [reactImage, 'React, React Native'], nextjs: [nextjsImage, 'Next'], redux: [reduxImage, 'Redux'], chakraUi: [chakraUiImage, 'Chakra UI'], tailwind: [tailwindImage, 'Tailwind CSS'], nodeJs: [nodeJsImage, 'Node'], express: [expressImage, 'Express'], mongodb: [mongodbImage, 'MongoDB'], mongoose: [mongooseImage, 'Mongoose'], awsS3: [awsS3Image, 'AWS-S3'], awsTextract: [awsTextractImage, 'AWS-Textrack'], gcp: [gcpImage, 'GCP'], postman: [postmanImage, 'Postman'], npm: [npmImage, 'NPM'], git: [gitImage, 'git'], github: [githubImage, 'Github'], sass: [sassImage, 'SaaS'] };

// Enter your Project Details here
export const projectDetails = [
  {
    title: "CalendarAi",
    image: projectImage1,
    description: 'The calendarAi is a convenient and intuitive web application designed to streamline the process of sceduling events.',
    techstack: 'React,Redux,ChakraUi,NodeJs,Express,Mongodb,Mongoose,AwsS3,AwsTextract',
    previewLink: "https://calendarai.vercel.app",
    githubLink: "https://github.com/RitikSingh11661/calendar.ai",
  },
  {
    title: "Connect Buddy",
    image: projectImage5,
    description: "It's the secure, proximity-based social app designed to help you find local friends based on matching vibes.",
    techstack: 'React Native (Expo), Node.js, Express.js,  MongoDB, Socket.io, WebRTC, Expo Push Notifications, REST APIs',
    previewLink: "https://play.google.com/store/apps/details?id=com.welcometodevelopers.connectbuddy",
    githubLink: "",
  },
  {
    title: "G.A.H Aaanya Homes",
    image: projectImage3,
    description: 'Quality homes, transparent service & personalized attention. From residential to commercial, we expertly bring your vision with precision & care.',
    techstack: 'React,Tailwindcss',
    previewLink: "https://aanyahomes.com",
    githubLink: "https://i.ibb.co/MPJ845k/aanyahomes.png",
  }
];

// Enter your Contact Details here
export const contactDetails = { email: "ritikofficial11661@gmail.com", phone: "+91 7217729644" };